import {QuotationSurveyPrepopulationRuleSchema} from "@feature/types";

export const LOGIC_QTYPE = ["none_f", "logic_from_design"];
export const LOGIC_DEPTYPE = ["simple", "conditional"];
export const LOGIC_VALTYPE: ("fixed" | "dynamic")[] = ["fixed", "dynamic"];
export const DATA_TRANSFER_ALLOWED_TYPES = ["number_input", "text_input", "bool"];